import React from 'react';
import './ReportTypes.css';

const BRAND_GRAD = 'linear-gradient(90deg,#6366F1,#8B5CF6 55%,#D946EF)';

const REPORT_TYPES = [
  { icon: 'bx-scan',           name: 'Radiographic Test',              note: 'RT',                                   custom: false },
  { icon: 'bx-broadcast',      name: 'Ultrasonic Test',                note: 'UT',                                   custom: false },
  { icon: 'bx-magnet',         name: 'Magnetic Particle',              note: 'MT',                                   custom: false },
  { icon: 'bx-droplet',        name: 'Liquid Penetrant',               note: 'PT',                                   custom: false },
  { icon: 'bx-search-alt',     name: 'Visual Inspection',              note: 'VT',                                   custom: false },
  { icon: 'bx-git-merge',      name: 'Weld Logs',                      note: 'Weld traceability',                    custom: false },
  { icon: 'bx-check-shield',   name: 'Procedures',                     note: 'Procedure records',                    custom: false },
  { icon: 'bx-award',          name: 'Certificates & Qualifications',  note: 'Personnel & equipment',                custom: false },
  { icon: 'bx-test-tube',      name: 'PQR / Techniques',               note: 'Qualified procedures',                 custom: false },
  { icon: 'bx-detail',         name: 'Specifications',                 note: 'Acceptance criteria',                  custom: false },
  { icon: 'bx-shield-quarter', name: 'API & Integrity Reports',        note: 'Asset integrity',                      custom: false },
  { icon: 'bx-layer-plus',     name: 'Custom Templates',               note: 'Any fixed-layout inspection document', custom: true  },
];

function ReportTypes() {
  return (
    <section style={{ background: '#131022', padding: '104px 56px' }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <div className="oc-reveal" style={{ textAlign: 'center', marginBottom: 48 }}>
          <span style={{ font: '700 12px Manrope,sans-serif', letterSpacing: '0.16em', color: '#816BFF' }}>SUPPORTED REPORT TYPES</span>
          <h2 style={{ margin: '14px 0 0', fontFamily: 'Montserrat,sans-serif', fontWeight: 800, fontSize: 38, letterSpacing: '-0.015em', color: '#fff' }}>
            If you have a picture or scan of the report, Oculo can extract it.
          </h2>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 18 }} className="oc-grid-3">
          {REPORT_TYPES.map((t) => (
            <div key={t.name} className="oc-reveal" style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 16, padding: '22px 22px', borderRadius: 12, background: t.custom ? 'rgba(217,70,239,0.07)' : 'rgba(255,255,255,0.03)', border: t.custom ? '1px solid rgba(217,70,239,0.25)' : '1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ flexShrink: 0, width: 50, height: 50, borderRadius: 11, background: 'rgba(99,102,241,0.10)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <i className={'bx ' + t.icon} style={{ fontSize: 26, background: BRAND_GRAD, WebkitBackgroundClip: 'text', backgroundClip: 'text', color: 'transparent' }} />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <span style={{ font: '700 15.5px Manrope,sans-serif', color: '#fff' }}>{t.name}</span>
                <span style={{ font: '500 12.5px Manrope,sans-serif', color: 'rgba(255,255,255,0.50)' }}>{t.note}</span>
              </div>
              {t.custom && (
                <span style={{ position: 'absolute', top: 14, right: 14, font: '700 9.5px Manrope,sans-serif', letterSpacing: '0.08em', color: '#D946EF' }}>EXTENSIBLE</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ReportTypes;
